import { createStore } from 'vuex'
import { request } from "@/api";
import { applyMixin } from './storeMixin'

const requireModules = require.context('./modules', false, /\.js$/)
const modules = requireModules.keys().reduce((modules, fileName) => {
  const name = fileName.match(/([^./]+)\.js$/)[1]
  modules[name] = requireModules(fileName).default
  return modules
}, {})

export default createStore(applyMixin({
  state: {
  },
  mutations: {
  },
  actions: {
    async getMixDisplayCategory2() {
      const resp = await request("Product/MixDisplayCategory", "post", {
        MallAccessToken: null,
        uid: null,
        appType: null,
        appVersion: null,
        callLocation: null,
      });
      if (resp.data !== undefined && resp.data !== null) {
        console.log("state.recommendedFilterList");
        console.log(resp.data.recommendedFilterList);
      }
    },
  },
  modules: modules
}))
